import React from 'react';

export const Logo = () => {
  return (
    <div className="logo">
      <img src="/images/logo.png" alt="Logo" />
    </div>
  );
};
